import Image from 'next/image'

export const SquareTokenImagesSection = () => {
  return (
    <>
      {/* top right */}
      <Image
        src='/images/club-gem.svg'
        alt='square Token Landing'
        className='-z-0 object-contain w-full h-auto fixed -top-5xl -right-[100px] sm:-right-10xl max-w-[173px] animate-[square-float-rotate-1_4s_ease-in-out_infinite]'
        width={173}
        height={173}
      />
      {/* top left */}
      <Image
        src='/images/club-gem.svg'
        alt='square Token Landing'
        className='-z-0 object-contain w-full h-auto fixed -top-[100px] sm:-top-10xl -left-[140px] sm:-left-3xl blur-lg max-w-[250px] animate-[square-float-rotate-2_6s_ease-in-out_infinite]'
        width={250}
        height={250}
      />
      {/* center left */}
      <Image
        src='/images/club-gem.svg'
        alt='square Token Landing'
        className='-z-0 object-contain w-full h-auto fixed top-1/2 -left-[80px] sm:-left-5xl blur-sm max-w-[120px] animate-[square-rotate-only_20s_linear_infinite]'
        width={120}
        height={120}
      />
      {/* bottom right */}
      <Image
        src='/images/club-gem.svg'
        alt='square Token Landing'
        className='-z-0 object-contain w-full h-auto fixed -bottom-10xl -right-[120px] sm:-right-8xl blur-sm max-w-[170px] animate-[square-float-rotate-3_5s_ease-in-out_infinite]'
        width={170}
        height={170}
      />
    </>
  )
}
